<template>
  <div id="appDetailPage">
    <a-card>
      <a-row style="margin-bottom: 16px">
        <a-col flex="auto">
          <h2>{{ data.appName }}</h2>
          <p>{{ data.appDesc }}</p>
          <p>应用类型：{{ APP_TYPE_MAP[data.appType] }}</p>
          <p>评分策略：{{ APP_SCORING_STRATEGY_MAP[data.scoringStrategy] }}</p>
          <p>
            <a-space>
              作者：
              <div
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#1D2129',
                }"
              >
                <a-avatar
                  :size="24"
                  :style="{ marginRight: '8px' }"
                  :image-url="data.user?.userAvatar"
                >
                </a-avatar>
                <a-typography-text>{{
                  data.user?.userName ?? "无名"
                }}</a-typography-text>
              </div>
            </a-space>
          </p>
          <p>
            创建时间：{{ dayjs(data.createTime).format("YYYY-MM-DD HH:mm:ss") }}
          </p>
          <a-space size="medium">
            <a-button type="primary" :href="`/answer/do/${id}`"
              >开始答题</a-button
            >
            <a-button type="primary" @click="doShare">分享应用</a-button>
            <a-button v-if="isMy" :href="`/add/question/${id}`"
              >设置题目</a-button
            >
            <a-button v-if="isMy" :href="`/add/scoring_result/${id}`"
              >设置评分</a-button
            >
            <a-button v-if="isMy" :href="`/add/app/${id}`">修改应用</a-button>
          </a-space>
        </a-col>
        <a-col flex="320px">
          <a-image width="100%" :src="data.appIcon"></a-image>
        </a-col>
      </a-row>
    </a-card>
    <ShareModal
      :link="shareLink"
      title="应用分享"
      ref="shareModalRef"
    ></ShareModal>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watchEffect } from "vue";
import API from "@/api";
import { getAppVoByIdUsingGet } from "@/api/appController";
import { Message } from "@arco-design/web-vue";
import { withDefaults, defineProps } from "vue";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import { useLoginUserStore } from "@/store/userStore";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import ShareModal from "@/components/ShareModal.vue";

interface Props {
  id: number;
}
const props = withDefaults(defineProps<Props>(), {
  id: () => {
    return 0;
  },
});

// 获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;

// 是否为本人创建
const isMy = computed(() => {
  return loginUserId && loginUserId == data.value.userId;
});

const data = ref<API.AppVO>({});

/*
 * 加载数据
 * */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getAppVoByIdUsingGet({
    id: props.id,
  });
  if (res.data.code === 0) {
    data.value = res.data.data ?? {};
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

watchEffect(() => {
  loadData();
});

const shareModalRef = ref();
// 分享弹窗的引用
const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${props.id}`;
// 分享
const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  // 阻止
  e.stopPropagation();
};
</script>

<style scoped>
#appDetailPage {
}

#appDetailPage .content-wrapper > * {
  margin-bottom: 24px;
}
</style>
